import { Intent } from '@blueprintjs/core';
import { showToasts } from '../../../lib/toaster';

/**
 * OptiID access token can expire, so on 401 error we show a toast informing user to refresh the page.
 * @param error - The error object to check
 * @returns true if it was a 401 error, false otherwise
 */
export const handleExpiredOptiAccessToken = (error: any): boolean => {
  const is401Error = (error?.response?.status === 401);
  if (is401Error) {
    showToasts([{
      intent: Intent.WARNING,
      message: 'Your session has expired. Please refresh your browser page to continue using Opal tools.'
    }]);
    return true;
  }
  return false;
};
